<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <text-input 
        disabled 
        :value="secondaryScraper.type">
        Type
      </text-input>
    </div>
    <div class="column">
      <text-input 
        disabled 
        :value="secondaryScraper.handler">
        Handler
      </text-input>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      <h5 class="title is-5">Scraping Payload</h5>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      <text-input 
        required
        :value="payload.identifier.name"
         @input="updateIdentifier"
        :error="$root.errorBag['scraper_payload.identifier.name']">
        Identifier
      </text-input>
    </div>
    <div class="column">
      <text-input 
        required
        :value="payload.extracts.class"
        @input="updateExtractionHandler"
        :error="$root.errorBag['scraper_payload.extracts.class']">
        Extraction Handler
      </text-input>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <submit-button 
        @submit="save"
        :working="working">
        Save
      </submit-button>
    </div>
  </div>
</loader>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    loading: true,
    working: false
  }),

  beforeCreate() {
    this.$store.dispatch(
      'secondaryScraper/loadSecondaryScraper', 
      this.$route.params.secondaryScraper
    ).finally(() => this.loading = false)
  },

  methods: {
    ...mapMutations('secondaryScraper', [
      'updateExtractionHandler',
      'updateIdentifier'
    ]),
    save() {
      this.working = true
      this.$store.dispatch('secondaryScraper/save').then(() => {
        this.working = false
        this.$toast.success('Saved')
      }).catch(error => this.working = false)
    }
  },

  computed: {
    ...mapGetters('secondaryScraper', [
      'secondaryScraper'
    ]),
    payload() {
      return this.secondaryScraper.scraper_payload
    }
  }
  
}
</script>